import React, {
  Dispatch, ReactElement, SetStateAction, useCallback, useEffect,
} from 'react';
import { SearchInputButton } from 'slovlex-idsk-react-components';
import NavrhAktuEuFilter from '../../../model/NavrhAktuEuFilter';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';

interface Props {
  setFilter: Dispatch<SetStateAction<NavrhAktuEuFilter>>,
  filterCopy: NavrhAktuEuFilter;
  label?: string;
  filterSearchText?: string;
  fieldName: keyof NavrhAktuEuFilter;
  onUpdateFieldCopy: SafeParameterSetter<NavrhAktuEuFilter>;
  className?: string;
}

const SearchInput = ({
  filterCopy,
  label,
  filterSearchText,
  setFilter,
  onUpdateFieldCopy,
  fieldName,
  className,
}: Props): ReactElement => {
  const onSubmit = useCallback(
    (): void => {
      setFilter(prevState => ({
        ...prevState,
        hladanyVyraz: filterCopy.hladanyVyraz,
        cisloLegislativnehoMaterialu: filterCopy.cisloLegislativnehoMaterialu,
        identifikatorAktu: filterCopy.identifikatorAktu,
        nazovLegislativnehoMaterialu: filterCopy.nazovLegislativnehoMaterialu,
        nazovAktu: filterCopy.nazovAktu,
        medziinstitucionalnyKod: filterCopy.medziinstitucionalnyKod,
        institucia: filterCopy.institucia,
        type: filterCopy.type,
      }));
    },
    [filterCopy.hladanyVyraz, filterCopy.cisloLegislativnehoMaterialu, filterCopy.identifikatorAktu,
      filterCopy.nazovLegislativnehoMaterialu, filterCopy.nazovAktu, filterCopy.medziinstitucionalnyKod,
      filterCopy.institucia, filterCopy.type, setFilter],
  );

  useEffect(() => {
    const keyDownHandler = async (e): Promise<void> => {
      if (e.key === 'Enter') {
        e.preventDefault();
        await onSubmit();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [onSubmit]);

  return (
    <SearchInputButton
      className={className}
      label={label}
      searchText={filterSearchText}
      setSearchText={(value: string) => onUpdateFieldCopy(fieldName, value)}
      onClearSearch={() => {
        onUpdateFieldCopy(fieldName, '');
      }}
      onButtonSubmit={onSubmit}
    />
  );
};

export default SearchInput;
